import React from "react";

import { Skeleton } from "components";

/**
 * Renders a Skeleton until isLoading is false
 *
 * @param    {isLoading} isLoading Display the skeleton when true
 * @param    {children} children Display the children when isLoading is false
 * @param    {type} type "block" | "paragraph" | "title"
 * @param    {height} height Sets the height of the Skeleton from type block
 * @param    {width} width Sets the width of the Skeleton from type title or paragraph
 * @param    {rows} rows Sets the number of rows (only for paragraph and title type)
 * @param    {buttonSize} buttonSize Sets the size of the Skeleton from type button
 * @param    {buttonShape} buttonShape Sets the shape of the Skeleton from type button
 * @param    {placeholder} skeleton A React Element to be rendered if isLoading is false. The default element is: <Skeleton type={type} height={height} />
 * @param    {className} className Class name
 * @returns Skeleton or children
 */
export const SkeletonWrapper = ({
  children,
  height,
  width,
  rows,
  isLoading,
  type,
  buttonShape,
  buttonSize,
  className = "",
  placeholder = <Skeleton type={type} height={height} width={width} rows={rows} buttonShape={buttonShape} buttonSize={buttonSize} className={className} />,
}) => (isLoading ? placeholder : children);
